(function() {
    angular.module('cfn').factory('seedCoreDataResolver', seedCoreDataResolver);

    seedCoreDataResolver.$inject = ['Seed', '$http'];

    function seedCoreDataResolver(Seed, $http) {
        const getSeed = Seed['get'];
        Seed.get = (param, callback) => {
            if (Seed.isSwissBartoUser) {
                // if we get the data for a single Seed also get the nutritional requirements (n, k2o, mg, p2o5, cropYield)
                callback = getNutritionalRequirements($http, callback);
            }
            return getSeed(param, callback);
        };

        return function() {
            return coreCommonResolveFunction(Seed, false);
        };
    }

    function getNutritionalRequirements($http, callback) {
        return (seedResponse) => {
            const seed = seedResponse.seed;
            if (seed.sysSeed && seed.sysSeed.sysCulture && seed.sysSeed.sysCulture.id) {
                return $http
                    .post('/365FarmNet/mod/catalog-service/rest/v1.0/cultures/nutritionalrequirements',
                        [seed.sysSeed.sysCulture.id])
                    .then(
                        ({data}) => {
                            if (data.length === 1) {
                                const nutritionalRequirements = data[0];
                                seed.k2o = nutritionalRequirements.k2o;
                                seed.mg = nutritionalRequirements.mg;
                                seed.n = nutritionalRequirements.n;
                                seed.p2o5 = nutritionalRequirements.p2o5;
                                seed.expectedCropYield = nutritionalRequirements.expectedCropYield;
                            }
                            return callback(seedResponse);
                        }
                    );
            } else {
                return new Promise((resolve) => resolve(callback(seedResponse)));
            }
        };
    }
})();
